// extracted by mini-css-extract-plugin
export default {"line":"EmptyText_line__GI452"};